(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};

    /**
     * The Menu Group used to populate the menu
     * @constructor
     */
    class MenuGroup {
        /**
         * Initialises the menu group based on the menu group passed in
         * @param menuGroup
         * @returns {Dashboard.Models.MenuGroup}
         */
        initialiseMenuGroup = function (menuGroup) {
            return _.extend(this, menuGroup);
        };

        /**
         * The text displayed on the menu
         * @type {string}
         */
        menuVal = "";

        /**
         * The class used for the icon for the menu item
         * @type {string}
         */
        iconClass = "";

        permissions = []

        /**
         * The brand menu items for this menu group
         * @type {Array}
         */
        brandItems = [];

        /**
         * The call center menu items for this menu group
         * @type {Array}
         */
        callCenterItems = [];

        /**
         * The store menu items for this menu group
         * @type {Array}
         */
        storeItems = [];

        /**
         * Returns the default menu item for a specific context
         * @param contextType
         */
        returnDefaultMenuItem(contextType) {
            switch (contextType) {
                case Dashboard.ContextTypes.BrandContext:
                    return _.findWhere(this.brandItems, { defaultState: true });
                case Dashboard.ContextTypes.CallCenterContext:
                    return _.findWhere(this.callCenterItems, { defaultState: true });
                case Dashboard.ContextTypes.StoreContext:
                    return _.findWhere(this.storeItems, { defaultState: true });
            }
        };

        /**
         * Returns true if the current menu group is the current group based on the state
         * @param currentState {string}
         */
        isGroupStateCurrent(currentState) {
            let isCurrent = _.some(this.brandItems, function (item) {
                if (item.stateConfig) {
                    return item.stateConfig.state === currentState;
                }
                return _.some(item.subMenuItems, function (subItem) {
                    return subItem.stateConfig &&
                        subItem.stateConfig.state === currentState;
                })
            });
            isCurrent = isCurrent || _.some(this.callCenterItems, function (item) {
                if (item.stateConfig) {
                    return item.stateConfig.state === currentState;
                }
                return _.some(item.subMenuItems, function (subItem) {
                    return subItem.stateConfig &&
                        subItem.stateConfig.state === currentState;
                })
            });
            isCurrent = isCurrent || _.some(this.storeItems, function (item) {
                if (item.stateConfig) {
                    return item.stateConfig.state === currentState;
                }
                return _.some(item.subMenuItems, function (subItem) {
                    return subItem.stateConfig &&
                        subItem.stateConfig.state === currentState;
                })
            });
            return isCurrent;
        };
        /**
         * Returns the default menu item for the group based on the current user context
         * @param currentContext {Dashboard.Models.Permissions.RoleContext}
         * @returns {MenuItem}
         */
        getDefaultMenuItemForContext(currentContext) {
            let menuItem = undefined;
            if (currentContext.BrandId && this.brandItems.length > 0) {
                menuItem = this.returnDefaultMenuItem(Dashboard.ContextTypes.BrandContext);
            } else if (currentContext.CallCenterId && this.callCenterItems.length > 0) {
                menuItem = this.returnDefaultMenuItem(Dashboard.ContextTypes.CallCenterContext);
            } else if (currentContext.StoreId && this.storeItems.length > 0) {
                menuItem = this.returnDefaultMenuItem(Dashboard.ContextTypes.StoreContext);
            }
            return menuItem;
        }
    }

    window.Dashboard.Models.MenuGroup = MenuGroup;
})();
